import { useState } from "react";
import PropTypes from "prop-types";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { Breadcrumb, Menu, Select, Spin } from "antd";
import Layout, { Content, Header } from "antd/lib/layout/layout";
import Sider from "antd/lib/layout/Sider";
import { useAuth } from "helpers/auth";
import { breadcrumbs } from "routes/routeData";
import CMenu from "components/CMenu";
import useAjax from "helpers/ajax";
import { getStore, setStore, showError } from "helpers/utility";

const getMenuState = () => {
  return getStore("menuState", { collapsed: false }).collapsed;
};

const LayoutMaster = ({ menuItems }) => {
  const {
    user: { displayName, companyName },
    logout,
  } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(getMenuState());
  const { get } = useAjax();

  const toggle = () => {
    setCollapsed(!collapsed);
    setStore("menuState", { collapsed: !collapsed });
  };

  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSearch = (value) => {
    if (value) {
      setLoading(true);
      get("api/v1/devices/search", { query: value })
        .then((resp) => {
          const items = resp.map((x) => {
            return {
              value: x.activationID,
              label: `${x.serialNo} (${x.companyName}) ${
                x.customerName ? " - " + x.customerName : ""
              }`,
              details: x,
            };
          });
          setOptions(items);
        })
        .catch((err) => showError(err))
        .finally(() => setLoading(false));
    } else {
      setOptions([]);
      setLoading(false);
    }
  };

  const onSelect = (value) => {
    const details = options.find((x) => x.details.activationID === value);
    navigate("/devices/devices/details", { state: details });
  };

  const location = useLocation();
  const pathSnippets = location.pathname.split("/").filter((i) => i);
  const extraBreadcrumbItems = pathSnippets.map((_, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join("/")}`;
    return <Breadcrumb.Item key={url}>{breadcrumbs[url]}</Breadcrumb.Item>;
  });
  const breadcrumbItems = [
    <Breadcrumb.Item key="home">Home</Breadcrumb.Item>,
  ].concat(extraBreadcrumbItems);

  return (
    <div className="container">
      <Layout>
        <Sider trigger={null} collapsible collapsed={collapsed} width={250}>
          <div className="logo">
            <Link to="/">{companyName}</Link>
          </div>
          <CMenu dataSource={menuItems} collapsed={collapsed} />
        </Sider>
        <Layout className="site-layout">
          <Header className="site-layout-background" style={{ padding: 0 }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div
                style={{
                  width: "50px",
                  // borderBottom: "5px solid #f0f0f0",
                }}
              >
                {collapsed ? (
                  <MenuUnfoldOutlined className="trigger" onClick={toggle} />
                ) : (
                  <MenuFoldOutlined className="trigger" onClick={toggle} />
                )}
              </div>
              <div style={{ flexGrow: "100" }}>
                <Menu
                  triggerSubMenuAction="click"
                  mode="horizontal"
                  defaultSelectedKeys={["3"]}
                  style={{ justifyContent: "flex-end" }}
                >
                  {/* <Menu.Item key="1" icon={<UserOutlined />}>
                    nav 1
                  </Menu.Item>
                  */}
                  <Menu.Item key="2">
                    <Select
                      placeholder="Search devices"
                      showSearch={true}
                      showArrow={false}
                      allowClear={true}
                      filterOption={false}
                      defaultActiveFirstOption={false}
                      notFoundContent={loading ? <Spin size="small" /> : null}
                      style={{ width: "250px" }}
                      onSelect={onSelect}
                      onSearch={handleSearch}
                      dropdownMatchSelectWidth={false}
                    >
                      {options.map((o) => (
                        <Select.Option key={o.value} value={o.value}>
                          {o.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Menu.Item>
                  <Menu.SubMenu
                    key="subKey1"
                    title={displayName}
                    icon={<UploadOutlined />}
                  >
                    <Menu.Item
                      key="4"
                      onClick={() => {
                        navigate("/security/changepassword");
                      }}
                    >
                      Change password
                    </Menu.Item>
                    <Menu.Divider />
                    <Menu.Item key="5" onClick={logout}>
                      Signout
                    </Menu.Item>
                  </Menu.SubMenu>
                </Menu>
              </div>
            </div>
          </Header>
          <Content
            className="site-layout-background"
            style={{
              margin: "16px 16px",
              padding: 24,
              minHeight: 280,
            }}
          >
            <div style={{ marginBottom: "20px" }}>
              <Breadcrumb>{breadcrumbItems}</Breadcrumb>
            </div>
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};
LayoutMaster.propTypes = {
  menuItems: PropTypes.array,
};
export default LayoutMaster;
